export const TOOLBAR_ID = 'id_toolbar'
export const EDITOR_REF_ID = 'quill-editor-ref'
